/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Guide_Start_TitleInputs */

const en_gc_resources_guide_start_title = /** @type {(inputs: Gc_Resources_Guide_Start_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open, edit and save your first XLSX.`)
};

const zh_gc_resources_guide_start_title = /** @type {(inputs: Gc_Resources_Guide_Start_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打开、编辑并保存首个 XLSX。`)
};

/**
* | output |
* | --- |
* | "Open, edit and save your first XLSX." |
*
* @param {Gc_Resources_Guide_Start_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_guide_start_title = /** @type {((inputs?: Gc_Resources_Guide_Start_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Guide_Start_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_guide_start_title(inputs)
	return zh_gc_resources_guide_start_title(inputs)
});
export { gc_resources_guide_start_title as "gc.resources.guide.start.title" }